/**
 * /admin/branding — Branding studio (route shell).
 * Screen impl lives in `./branding-screen.tsx` and is dynamic-imported so
 * the studio's font + tone fixtures don't ship in the initial bundle.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/branding')({
  component: lazyRouteComponent(() => import('./branding-screen'), 'StudioBoard'),
});
